<template>
  <div class="home-layout">
    <a-row class="grid-demo">
      <a-col :span="20">
        <div class="home-left">
          <div class="stats-and-chart">
            <div class="stats-row">
              <HomeStatsCard v-for="(item, idx) in statsList" :key="idx" :icon="item.icon" :title="item.title" :value="item.value" />
            </div>
            <HomeEmployeeBarChart :data="employeeStats" />
          </div>
        </div>
      </a-col>
      <a-col :span="4">
        <div class="home-right">
          <HomeUserInfo :user="userInfo" />
          <HomeServerStatus :status="serverStatus" />
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import HomeStatsCard from '@/components/HomeStatsCard.vue'
import HomeEmployeeBarChart from '@/components/HomeEmployeeBarChart.vue'
import HomeUserInfo from '@/components/HomeUserInfo.vue'
import HomeServerStatus from '@/components/HomeServerStatus.vue'

export default {
  name: 'HomeView',
  components: {
    HomeStatsCard,
    HomeEmployeeBarChart,
    HomeUserInfo,
    HomeServerStatus
  },
  data() {
    return {
      statsList: [
        { icon: 'stamp', title: '待我审批工单', value: 3 },
        { icon: 'interaction', title: '门店数', value: 12 },
        { icon: 'nav', title: '任务单数', value: 25 },
        { icon: 'subscribe', title: '工单总数', value: 99999999 },
        { icon: 'subscribed', title: '已完成工单数', value: 80 }
      ],
      employeeStats: [
        { name: '张三', total: 125, finished: 18 },
        { name: '李四', total: 15, finished: 12 },
        { name: '王五', total: 30, finished: 28 },
        { name: '赵六', total: 10, finished: 9 },
        { name: '张三', total: 20, finished: 18 },
        { name: '李四', total: 15, finished: 12 },
        { name: '王五', total: 30, finished: 28 },
        { name: '赵六', total: 10, finished: 9 },
        { name: '张三', total: 20, finished: 18 },
        { name: '李四', total: 15, finished: 12 },
        { name: '王五', total: 30, finished: 28 },
        { name: '赵六', total: 10, finished: 9 }
      ],
      userInfo: {
        name: '管理员',
        role: '系统管理员',
        email: 'admin@example.com',
        avatar: ''
      },
      serverStatus: {
        cpu: 32,
        memory: 68,
        disk: 55,
        dbConnected: true
      }
    }
  }
}
</script>

<style scoped>
.home-layout {
  display: flex;
  flex-direction: row;
  height: 100%;
  background: var(--color-bg-1);
  padding: 32px 24px;
  box-sizing: border-box;
}

.stats-row {
  display: flex;
  flex-direction: row;
  margin-bottom: 24px;
  width: 100%;
  gap: 16px;
}
.stats-and-chart {
  width: 100%;
  display: flex;
  flex-direction: column;
}
.stats-row {
  width: 100%;
}
.home-left {
  margin-right: 24px;
  display: flex;
  flex-direction: column;
}
.home-right {
  min-width: 280px;
  text-align: center;

}
</style>
